export default __webpack_public_path__ + "static/portfolio-15-342ff5b0bc0038ba679dd62e193b4dca.jpg";